import React from 'react';
import classnames from 'classnames';
import { AirtameVariants, useVariantContext } from './variant-context-provider';
import {
  IconCheckmarkCircle,
  IconExclamationCircle,
  IconInformationSolid,
  IconWarningSign,
} from '../icons';

type VariantIconProps = { variant: AirtameVariants } & React.SVGProps<SVGSVGElement>;
const VariantIcon = ({ variant, ...props }: VariantIconProps): React.ReactElement | null => {
  switch (variant) {
    case 'error':
      return <IconExclamationCircle {...props} />;
    case 'informative':
      return <IconInformationSolid {...props} />;
    case 'positive':
      return <IconCheckmarkCircle {...props} />;
    case 'warning':
      return <IconWarningSign {...props} />;
    case 'default':
    default:
      return null;
  }
};

export type DialogHeaderIconProps = Omit<VariantIconProps, 'variant'>;

export const DialogHeaderIcon = ({
  className,
  ...props
}: DialogHeaderIconProps): React.ReactElement => {
  const { variant } = useVariantContext();
  const classNames = classnames(className, `airtame-dialog__header-icon`);

  return <VariantIcon className={classNames} variant={variant} {...props} />;
};

DialogHeaderIcon.displayName = 'DialogHeaderIcon';
